import { createContext, useContext } from 'react';
import { UseFormEventQCScriptProps } from '../types';

const QCSFormEventContext = createContext<UseFormEventQCScriptProps>({} as UseFormEventQCScriptProps);

export const useQCSFormEvent = (): UseFormEventQCScriptProps => useContext(QCSFormEventContext);

export const QCSFormEventProvider = QCSFormEventContext.Provider;
